<template>
    <div v-if="entradas_por_cp" class="table-responsive m-0">
        <span style="font-size: 17.6px; font-weight: 400; color: rgb(68, 68, 68); font-family: Oswald, sans-serif; margin: 5px; padding: 3px;">Total de entradas por CP</span>
        <div class="table-responsive">
            <b-table :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" hover :items="entradas_por_cp" :fields="fields" id="cp-table" :per-page="perPage" :current-page="currentPage">
                <template #cell(cp)="data">
                    {{ data.item.cp ? data.item.cp : '-' }}
                </template>
                <template #cell(provincia)="data">
                    {{ data.item.provincia_nombre ? data.item.provincia_nombre : '-' }}
                </template>
                <template #cell(poblacion)="data">
                    {{ data.item.localidad_nombre ? data.item.localidad_nombre : '-' }}
                </template>
                <template #cell(count)="data">
                    {{ data.item.total }}
                </template>
            </b-table>
        </div>
        <b-pagination :per-page="perPage" aria-controls="cp-table" v-model="currentPage" :total-rows="entradas_por_cp.length" size="sm"/>
    </div>
</template>

<script>
    export default {
        props: ['event_id'],
        data() {
            return {
                sortBy: 'total',
                sortDesc: true,
                fields: [
                    { key: 'cp', label: 'CP/ZIP CODE', class: 'cp'},
                    { key: 'provincia', label: 'Provincia', class: 'provincia'},
                    { key: 'poblacion', label: 'Poblacion', class: 'poblacion'},
                    { key: 'total', label: 'Total', class: 'total', 'sortable': true },
                ],
                cpToInfo: {},
                perPage: 10,
                currentPage: 1,
                entradas_por_cp: null
            }
        },
        created() {
            this.getTotalEntradasPorCp();
        },
        methods: {
            getTotalEntradasPorCp() {
                const params = {
                    filters : {},
                    evento_id: this.event_id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.informe.total-entradas-por-cp'), params).then(res => {
                    this.entradas_por_cp = res.data;

                    this.$emit('totalEntradasCP', this.entradas_por_cp);
                });
            },
        }
    }
</script>